import React, { useState ,useEffect} from 'react'
import AutoDropDown from '../ReusableComponents/AutoCompleteDropDown'
import InputText from '../ReusableComponents/InputText'
import { ConsumptionView } from '../components/HeaderAttribute';
import GridPage from '../components/GridPage';

const ConsumptionViewPopUp=({data, data1 })=> {
     

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); 
  };

  
  
return (
    <div class="w-full p-5">
      <div class=" border-black  "></div>
      <GridPage
         title={`Issues > ${data.ConsumptionNo} > ${formatDate(data.ConsumeDate).replaceAll("/", "-")}`}
        header={ConsumptionView}
        records={data1}
        addView={true}
        tableHeight="h-60 overflow-y-auto"
      />
    </div>
  );
}

export default ConsumptionViewPopUp
